module.exports = __webpack_public_path__ + "static/media/Component2.87762fe9.png";